import { render, staticRenderFns } from "./IM_2_6.vue?vue&type=template&id=1c5cbba8&scoped=true&"
import script from "./IM_2_6.vue?vue&type=script&lang=js&"
export * from "./IM_2_6.vue?vue&type=script&lang=js&"
import style0 from "./IM_2_6.vue?vue&type=style&index=0&id=1c5cbba8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5cbba8",
  null
  
)

export default component.exports